import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import eventLogService, { EventLogEvent } from '../services/eventLog.service';

type Filters = {
  eventType?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
};

const useEventLogEvents = (clinicId: number, filters?: Filters, enabled = true) => {
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: EventLogEvent[]; skip?: number; count: number }>(
    [
      'eventLogEvents',
      clinicId,
      filters?.eventType,
      filters?.userId,
      filters?.startDate,
      filters?.endDate,
    ],
    async (context: QueryFunctionContext) => {
      return eventLogService.listEvents(clinicId, {
        skip: context.pageParam,
        eventType: filters?.eventType,
        userId: filters?.userId,
        startDate: filters?.startDate,
        endDate: filters?.endDate,
      });
    },
    {
      getNextPageParam: lastGroup => lastGroup?.skip || undefined,
      refetchOnWindowFocus: false,
      enabled: enabled && !!clinicId,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};

export default useEventLogEvents;
